import { ReactNode, useState } from 'react';
import classNames from 'classnames';

import { OrderTypeEnum } from '../../lib/enums/order-type.enum';
import { SORExtendedHoursMarker, SOROrderSide, SOROrderTimeInForce } from '../../lib/models/gateway/types';

import ButtonsCancelAndModify from '../TableView/tableContainer/ButtonsCancelAndModify/ButtonsCancelAndModify';

import { SWIPE_DISTANCE_LIMIT } from './constants';

import styles from './SymbolDetailsButtons.module.scss';

export type SymbolDetailsButtonsRow = {
  id: string;
  totalQuantity: number;
  setPrice: string;
  type: string;
  expiryDate: ReactNode;
  name: string;
  side: SOROrderSide;
  plainType: OrderTypeEnum.Market | OrderTypeEnum.Limit | OrderTypeEnum.Stop;
  initialPrice: number | null;
  partialFillQuantity: number;
  tradingSessionId: SORExtendedHoursMarker;
  timeInForce: SOROrderTimeInForce;
  companyName?: string;
};

type Props = {
  data: SymbolDetailsButtonsRow[];
  activeRowStyle: string;
}

const SymbolDetailsButtons = ({ activeRowStyle, data }: Props) => {
  const [swipedRow, setSwipedRow] = useState<number | undefined>(undefined);

  let touchStartX = 0;
  let touchEndX = 0;

  const handleTouchStart = (e) => {
    touchStartX = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX = e.touches[0].clientX;
  };

  const handleTouchEnd = (event: React.TouchEvent, index: number) => {
    const changedTouches = event?.changedTouches;
    const endX = (changedTouches?.[0]) ? changedTouches[0].clientX : touchEndX;
    const swipeDistance = touchStartX - endX;
    if (swipeDistance > SWIPE_DISTANCE_LIMIT) {
      setSwipedRow(index);
    } else if (swipeDistance < -SWIPE_DISTANCE_LIMIT) {
      setSwipedRow(undefined);
    }
  };

  return (
    <div className={styles.wrapperPendingOrdersTable}>
      {data.map((row, index: number) => (
        <div
          key={row.id}
          className={classNames(styles.wrapperRow)}
        >
          <div
            className={classNames(styles.row, {
              [styles.rowSwipped]: swipedRow === index,
            })}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={(e) => handleTouchEnd(e, index)}
          >
            <div className={styles.order}>
              <div className={styles.orderValueAndDate}>
                <div>
                  <div className={styles.quantityAndPrice}>
                    <span>
                      {row.totalQuantity}
                    </span>
                    <span>
                      x
                    </span>
                    <span>
                      {row.setPrice}
                    </span>
                  </div>
                  <div className={styles.orderType}>
                    {row.type}
                  </div>
                </div>
                <div className={styles.expiryDate}>
                  {row.expiryDate}
                </div>
              </div>
            </div>
            <ButtonsCancelAndModify row={row} isSwipeable />
          </div>
        </div>
      ))}
    </div>
  );
};
export default SymbolDetailsButtons;
